import JSEncrypt from "jsencrypt";

const win: any = window;

export function encrypt(value: any) {
    const CEM_PublicKey = win["cem_keycloak_public_key"];
    const RSAEncrypt = new JSEncrypt();

    RSAEncrypt.setPublicKey(CEM_PublicKey);
    const encryptedMessage = RSAEncrypt.encrypt(value);

    return encryptedMessage;
}